<template>
  <button
    class="currency-switcher-card"
    :disabled="isSelected || currencyRatePending || backEndError"
    @click="currencySelected"
  >
    <div
      v-if="false"
      class="currency-flag"
    />
    <div class="currency-details">
      <span
        class="currency-iso"
        v-html="`${item.Symbol} ${parsedCurrencyIso ? parsedCurrencyIso : item.IsoCode}`"
      />
      <span
        class="currency-name"
        v-html="parsedName ? parsedName : item.Name"
      />
      <loading-dots v-if="isSelecting && currencyRatePending" />
      <hr
        aria-hidden="true"
        class="separator"
      >
    </div>
  </button>
</template>

<script>
  import { highlightMatch } from '@utils/highlight-match'
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    name: 'CurrencyCard',
    props: {
      item: {
        type: Object,
        default: () => ({})
      },
      searchInput: {
        type: String,
        default: ''
      },
      queryChanged: {
        type: Number,
        default: -1
      },
      baseCurrency: {
        type: String,
        default: ''
      }
    },
    data: () => ({
      searchString: '',
      isSelecting: false
    }),
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapState('currency', ['currencyRatePending', 'selectedCurrency', 'backEndError']),
      ...mapGetters('currency', ['currentCurrency', 'orSelected']),
      isSelected() {
        return this.item.IsoCode === this.orSelected(this.baseCurrency || this.currentCurrency)
      },
      parsedCurrencyIso: {
        get() {
          return highlightMatch(this.searchString, this.item.IsoCode, 'bold-highlighted')
        },
        set(newValue) {
          this.searchString = newValue
        }
      },
      parsedName: {
        get() {
          return highlightMatch(this.searchString, this.item.Name, 'bold-highlighted')
        },
        set(newValue) {
          this.searchString = newValue
        }
      },
    },
    watch: {
      searchInput(val) {
        if (val) {
          this.searchString = val
        } else {
          this.searchString = ''
        }
      },
      queryChanged() {
        this.searchString = this.searchInput
      }
    },
    methods: {
      ...mapActions('currency', ['changeCurrency']),
      async currencySelected() {
        this.isSelecting = true
        this.$emit('selecting-currency', this.item.IsoCode)
        if (this.baseCurrency) {
          await this.changeCurrency({
            toCurrency: this.item.IsoCode,
            fromCurrency: this.baseCurrency
          })
        } else {
          await this.changeCurrency(this.item.IsoCode)
        }
        if (!window.adobeDataLayer) {
          this.$track({
            events: {
              siteInteraction: true
            },
            interaction: {
              name: 'currency change',
              type: 'selector'
            },
            booking: {
              currency: this.currentCurrency
            }
          })
        }
      }
    }
  }
</script>
